/*
  「エンジニアの今」(components/EngineerMarket.tsx) の CSS。値は 2026-10 のオーナーとの見本 (itjobs v12) から写した。
  色は hp-base.ts の変数 (--cream、--ink、--sub、--yellow、--blue、--red、--line)。見本にだけある薄い灰は .em の中の --em-muted に置く。
  字は app.css が body * に var(--font-body-ja) を !important で当てているので、明朝と等幅は --font-body-ja を置き直して切り替える。
  動きは付けない。節の頭は hx-head 系の部品を使わず、hp の入場の動き (motion.ts) の対象にしない。
*/
export const ENGINEER_CSS = `
.hp .em{--em-muted:#CFC9BA;--em-del:#6B6B74;padding-top:32px;padding-bottom:28px;background-color:var(--cream);background-image:linear-gradient(rgba(14,14,16,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(14,14,16,.05) 1px,transparent 1px);background-size:22px 22px;line-height:1.6;overflow-x:clip}
.hp .em-nw{white-space:nowrap}
.hp .em del{position:relative;color:var(--em-del);text-decoration:none;white-space:nowrap}
.hp .em del::after{content:"";position:absolute;left:-4%;right:-4%;top:52%;height:.14em;background:var(--red);transform:rotate(-6deg);border-radius:2px}
.hp .em mark{background:linear-gradient(transparent 58%,var(--yellow) 58%);color:inherit;padding:0 2px;white-space:nowrap;-webkit-box-decoration-break:clone;box-decoration-break:clone}

/* 節の頭 */
.hp .em-head{text-align:center}
.hp .em-head .hx-flag{margin:0 auto 10px}
.hp .em-kick{--font-body-ja:var(--mincho);margin:0 0 4px;font-weight:700;font-size:16px;line-height:1.6}
.hp .em-h2{--font-body-ja:var(--mincho);margin:4px 0 0;font-weight:var(--h2-w);font-size:clamp(21px,6.4vw,26px);line-height:1.5;letter-spacing:0}
.hp .em-ng{background:var(--ink);color:var(--yellow);padding:0 8px;border-radius:4px}
.hp .em-hope{margin:10px 0 0;font-size:14px;font-weight:700}

/* 3段 */
.hp .em-step{margin-top:20px}
.hp .em-sh{display:flex;align-items:center;gap:8px;margin:0 0 10px}
.hp .em-no{--font-body-ja:var(--mono);flex:none;font-size:12px;font-weight:600;line-height:1.6;background:var(--ink);color:var(--yellow);border-radius:999px;padding:2px 10px}
.hp .em-h3{--font-body-ja:var(--mincho);margin:0;font-weight:700;font-size:19px;line-height:1.5;letter-spacing:0}
.hp .em-sh-stack{flex-direction:column;align-items:flex-start;gap:6px}
.hp .em-sh-stack .em-h3{font-size:clamp(17px,5.2vw,19px)}
.hp .em-card{background:#fff;border:2px solid var(--ink);border-radius:12px;padding:14px;box-shadow:4px 4px 0 var(--ink)}
.hp .em-src{margin:10px 0 0;font-size:12px;line-height:1.55;color:var(--sub)}
.hp .em-sub{margin:14px 0 6px;border-top:1px dashed var(--em-muted);padding-top:10px;font-size:12px;font-weight:900;line-height:1.6}

/* くわしく見る (中の図は SEO のため消さず畳む)。印は hx-dt と同じく CSS で描く */
.hp .em-more{margin-top:10px;border-top:1px dashed var(--em-muted)}
.hp .em-more>summary{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:44px;cursor:pointer;list-style:none;font-size:12.5px;font-weight:900;line-height:1.5}
.hp .em-more>summary::-webkit-details-marker{display:none}
.hp .em-more>summary::after{content:"";flex:none;width:12px;height:12px;background:linear-gradient(var(--ink),var(--ink)) center/100% 2px no-repeat,linear-gradient(var(--ink),var(--ink)) center/2px 100% no-repeat}
.hp .em-more[open]>summary::after{background:linear-gradient(var(--ink),var(--ink)) center/100% 2px no-repeat}
.hp .em-more>summary:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}
.hp .em-more[open]>summary{border-bottom:1px dashed var(--em-muted)}
.hp .em-more>.em-chips{margin-top:10px}
.hp .em-src-short{margin-top:6px}

/* 01 1人あたりの求人 */
.hp .em-q{display:flex;align-items:center;gap:12px;margin:2px 0 16px;font-size:18px;font-weight:900;line-height:1.45}
.hp .em-q b{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-size:22px;padding:0 2px}
.hp .em-q-ic{flex:none;display:grid;place-items:center;width:48px;height:48px;border-radius:50%;background:var(--ink);color:#fff}
.hp .em-q-ic svg{width:28px;height:28px}
.hp .em-pp{display:grid;gap:14px}
.hp .em-pp-row{display:grid;gap:6px;padding:12px;border-radius:10px;background:var(--cream)}
.hp .em-pn{display:flex;align-items:baseline;justify-content:space-between;gap:10px;font-size:16px;font-weight:700;line-height:1.3}
.hp .em-pn b{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-size:44px;font-weight:900;line-height:1;letter-spacing:-.02em;color:var(--sub)}
.hp .em-pn b small{font-size:18px;margin-left:2px;letter-spacing:0}
.hp .em-icons{display:flex;flex-wrap:wrap;gap:4px}
.hp .em-ic{position:relative;display:block;width:26px;height:26px;color:#8E8A80}
.hp .em-ic svg{display:block;width:100%;height:100%}
.hp .em-part{background:#E9E4D6;border-radius:3px}
.hp .em-clip{position:absolute;top:0;bottom:0;left:0;overflow:hidden}
.hp .em-hi{background:#FFF8CC;outline:2px solid var(--ink)}
.hp .em-hi .em-ic{color:var(--ink)}
.hp .em-hi .em-pn{font-weight:900}
.hp .em-hi .em-pn b{color:var(--ink);background:linear-gradient(transparent 62%,var(--yellow) 62%);padding:0 2px}
.hp .em-say{--font-body-ja:var(--mincho);margin:16px 0 4px;text-align:center;font-size:24px;font-weight:700;line-height:1.5}
.hp .em-note{margin:0;font-size:14px;line-height:1.7}
.hp .em-note b{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-weight:700}
.hp .em-more .em-pp-row{padding:8px 12px}
.hp .em-more .em-pn b{font-size:28px}
.hp .em-chips{display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-top:12px}
.hp .em-chip{background:var(--cream);border-radius:8px;padding:8px 9px;font-size:12px;line-height:1.5}
.hp .em-chip b{display:block;margin-bottom:2px;font-size:12px}
.hp .em-chip-v{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-size:13px;font-weight:700}
.hp .em-chip-rest span{white-space:nowrap}
.hp .em-chip-v em{font-style:normal;background:var(--yellow);padding:0 3px}

/* 職種別の求人倍率 */
.hp .em-bars{display:grid;grid-template-columns:8.6em 1fr 4.2em;gap:3px 8px;align-items:center}
.hp .em-bar-row{display:contents}
.hp .em-bn{font-size:12px;line-height:1.25}
.hp .em-bv{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-size:12px;font-weight:700;text-align:right;white-space:nowrap}
.hp .em-track{height:11px}
.hp .em-b{display:block;height:100%;border-radius:2px;background:var(--em-muted)}
.hp .em-b-hi{background:var(--yellow);border:1.5px solid var(--ink)}
.hp .em-b-base{background:var(--ink)}
.hp .em-hit{font-weight:900}

/* ハローワークの求人の数 (棒は右から伸びる) */
.hp .em-drop{display:grid;grid-template-columns:1fr 4.4em;gap:2px 8px;align-items:center;font-size:12px;margin-top:6px}
.hp .em-drop-row{display:contents}
.hp .em-drop-n{grid-column:1 / -1;display:flex;justify-content:space-between;gap:8px;margin-top:6px;line-height:1.3}
.hp .em-drop-n small{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-size:12px;color:var(--sub);white-space:nowrap}
.hp .em-drop-track{position:relative;height:12px;background:var(--cream);border-radius:3px}
.hp .em-drop-track i{position:absolute;right:0;top:0;bottom:0;background:#B9B4A8;border-radius:3px}
.hp .em-drop-v{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-weight:700;text-align:right}
.hp .em-drop-dn .em-drop-track i{background:var(--red)}
.hp .em-drop-dn .em-drop-n,.hp .em-drop-dn .em-drop-v{color:var(--red);font-weight:900}
.hp .em-drop-up .em-drop-track i{background:#C9A800}
.hp .em-drop-up .em-drop-v{background:var(--yellow);padding:0 3px}
.hp .em-sub-tight{margin-top:6px}

/* 推移の線グラフ */
.hp .em-line-svg{display:block;width:100%;height:auto}
.hp .em-grid{stroke:#e3dccb}
.hp .em-tick{font-size:12px;fill:var(--sub)}
.hp .em-gpt-line{stroke:var(--red);stroke-dasharray:3 3}
.hp .em-line-all{fill:none;stroke:var(--ink);stroke-width:1.4}
.hp .em-line-eng{fill:none;stroke:#C9A800;stroke-width:2.2}
.hp .em-dot-last{fill:var(--yellow);stroke:var(--ink)}
.hp .em-dot-gpt{fill:var(--red)}
.hp .em-val{font-size:12px;font-weight:700}
.hp .em-val-gpt{fill:var(--red)}
.hp .em-legend{display:flex;flex-wrap:wrap;gap:4px 10px;margin:4px 0 0;font-size:12px}
.hp .em-legend i{display:inline-block;width:12px;height:3px;margin-right:3px;vertical-align:middle}
.hp .em-lg-eng{background:#C9A800;height:4px!important}
.hp .em-lg-all{background:var(--ink)}
.hp .em-lg-gpt{color:var(--red)}

/* 02 求められること */
.hp .em-need{display:grid;gap:12px}
.hp .em-nc{padding:14px 16px;color:var(--ink)}
.hp .em-nc-top{display:flex;align-items:center;gap:10px}
.hp .em-nc-top .em-k{margin-left:auto}
.hp .em-nc-ic{flex:none;display:grid;place-items:center;width:40px;height:40px;border-radius:10px;background:var(--cream)}
.hp .em-nc-ic svg{width:24px;height:24px}
.hp .em-k{--font-body-ja:var(--mono);height:fit-content;font-size:13px;font-weight:600;line-height:1.6;background:var(--blue);color:#fff;border-radius:4px;padding:1px 8px}
.hp .em-nc h4{margin:0;font-size:19px;font-weight:900;line-height:1.4}
.hp .em-nc-b{display:grid;grid-template-columns:auto 1fr;gap:12px;align-items:center;margin-top:10px}
.hp .em-nc-num{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;margin:0;font-size:42px;font-weight:900;line-height:1;letter-spacing:-.02em}
.hp .em-nc-cap{margin:0;font-size:16px;font-weight:700;line-height:1.55;color:var(--ink);word-break:auto-phrase}
.hp .em-nc-cap small{display:block;margin-top:2px;font-size:13px;font-weight:400;color:var(--sub)}
.hp .em-need-more{list-style:none;margin:10px 0 0;padding:0;display:grid;gap:8px;font-size:14px;line-height:1.7}
.hp .em-need-more li{display:grid;grid-template-columns:auto 1fr;gap:10px;align-items:start}
.hp .em-need-more .em-k{margin-top:3px}
.hp .em-need-more b{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-weight:700}
.hp .em-card-more{margin-top:12px;padding:0 14px;box-shadow:none}
.hp .em-more-top{margin-top:0;border-top:0}
.hp .em-more-top>summary{font-size:15px}
.hp .em-more-top[open]{padding-bottom:14px}
.hp .em-dv{display:grid;grid-template-columns:minmax(0,1fr) max-content minmax(0,1fr);gap:3px 6px;align-items:center;font-size:12px}
.hp .em-dv-row{display:contents}
.hp .em-dv-hd{font-size:12px;font-weight:700;color:var(--sub)}
.hp .em-dv-hl{text-align:right}
.hp .em-dv-n{text-align:center;font-size:12px;line-height:1.2;white-space:nowrap}
.hp .em-dv-hi{font-weight:900;background:var(--yellow);border-radius:3px}
.hp .em-dv-l,.hp .em-dv-r{display:flex;align-items:center;gap:4px;--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-size:12px;font-weight:700}
.hp .em-dv-l{justify-content:flex-end}
.hp .em-dv-l i,.hp .em-dv-r i{display:block;height:10px;border-radius:2px}
.hp .em-dv-l i{background:var(--blue)}
.hp .em-dv-r i{background:var(--red)}
.hp .em-down{margin-top:12px;background:#fff;border:2px solid var(--ink);border-radius:12px;padding:16px;text-align:center;color:var(--ink)}
.hp .em-down-say{--font-body-ja:var(--mincho);margin:0;font-size:22px;font-weight:700;line-height:1.5}
.hp .em-down-num{margin:6px 0 0;font-size:13px;line-height:1.6;color:var(--sub)}
.hp .em-down-num b{--font-body-ja:var(--gothic);font-variant-numeric:tabular-nums;font-weight:700;color:var(--red)}

/* 03 ゆめさくでやっていること。見出しの形は節の頭と同じ (赤線で消して、黄のマーカーで答える) */
.hp .em-lead3{margin:0 0 10px;font-size:16px;font-weight:900;line-height:1.6}
.hp .em-do{display:grid;gap:12px}
.hp .em-do .em-it{display:grid;grid-template-columns:auto 1fr;gap:6px 10px;align-content:start;background:#fff;color:var(--ink);border:2px solid var(--ink);border-radius:12px;padding:14px;box-shadow:4px 4px 0 var(--ink)}
.hp .em-do .em-k{margin-top:4px;background:var(--yellow);color:var(--ink)}
.hp .em-do h4{margin:0;font-size:18px;font-weight:900;line-height:1.45}
.hp .em-do p{margin:4px 0 0;font-size:16px;line-height:1.65;word-break:auto-phrase}
.hp .em-do-img{grid-column:1 / -1;display:block;width:100%;height:96px;margin-top:6px;object-fit:cover;border:1px solid var(--em-muted);border-radius:8px}
.hp .em-end{--font-body-ja:var(--mincho);margin:12px 0 0;text-align:center;font-weight:700;font-size:18px;line-height:1.6}
.hp .em-asof{margin:6px 0 0;text-align:right;font-size:12px;color:var(--sub)}

@media (min-width:768px){
  .hp .em{padding-top:56px;padding-bottom:48px}
  .hp .em-brs{display:none}
  .hp .em-kick{font-size:21px}
  .hp .em-h2{font-size:34px}
  .hp .em-steps{max-width:860px;margin:0 auto}
  .hp .em-sh-stack{flex-direction:row;align-items:center;gap:8px}
  .hp .em-sh-stack .em-h3{font-size:19px}
  .hp .em-line{max-width:520px}
  .hp .em-bars{grid-template-columns:11em 1fr 5em}
  .hp .em-dv{grid-template-columns:minmax(0,1fr) 11em minmax(0,1fr)}
  .hp .em-do{grid-template-columns:1fr 1fr 1fr;align-items:stretch}.hp .em-do h4{min-height:2lh}.hp .em-do .em-do-img{align-self:end;margin-top:auto}
  .hp .em-need{grid-template-columns:1fr 1fr 1fr}
  .hp .em-nc-b{grid-template-columns:1fr;gap:6px}
  .hp .em-nc-top{gap:8px}
  .hp .em-nc-ic{width:36px;height:36px}
  .hp .em-nc h4{font-size:17px;white-space:nowrap}
  .hp .em-nc-num{font-size:48px}
  .hp .em-do-img{height:130px}
  .hp .em-pp{grid-template-columns:1fr 1fr}
  .hp .em-more .em-pp{grid-template-columns:1fr}
  .hp .em-q{justify-content:center;font-size:20px}
  .hp .em-say{font-size:28px}
  .hp .em-down-say{font-size:28px}
}
`;
